import {
  mpReconciliationStatus,
  ReceivedInvoiceReconciliationStatus,
} from '@/context/services/invoice/type';
import { useTranslation } from '@/i18n';
import {
  IconApproval,
  IconCancel,
  IconPending,
  Tag,
} from '@moneyforward/ap-frontend-components';
import { FC, memo } from 'react';
import styles from '../../columns.module.scss';

type Props = {
  status: ReceivedInvoiceReconciliationStatus | undefined;
};

export const ReconciliationStatusTag: FC<Props> = memo(({ status }) => {
  const { t } = useTranslation();

  if (!status || status === mpReconciliationStatus.unset) {
    return null;
  }

  if (status === mpReconciliationStatus.excluded) {
    return (
      <Tag
        status='default'
        closable={false}
        outline={false}
        size='small'
        customIcon={<IconCancel size={12} />}
      >
        {t('received_invoice_reconciliation_status_excluded')}
      </Tag>
    );
  }

  if (status === mpReconciliationStatus.waiting) {
    return (
      <Tag
        status='success'
        closable={false}
        outline={false}
        size='small'
        customIcon={<IconPending size={12} />}
      >
        {t('received_invoice_reconciliation_status_waiting')}
      </Tag>
    );
  }

  return (
    <Tag
      status='default'
      closable={false}
      outline={false}
      size='small'
      customIcon={
        <IconApproval
          size={12}
          className={styles['receivedInvoiceIdIconApplied']}
        />
      }
    >
      {t('received_invoice_reconciliation_status_sent')}
    </Tag>
  );
});
ReconciliationStatusTag.displayName = 'ReconciliationStatusTag';
